import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  ReactNode,
} from "react";
import { motion, AnimatePresence } from "framer-motion";
//styles
import styles from "./modal.module.scss";
import classNames from "classnames";

export interface ModalPropsType {
  show: boolean;
  children: ReactNode;
  onClose: () => void;
}

const Modal = ({ show, children, onClose }: ModalPropsType) => {
  const [open, setOpen] = useState<boolean>(show);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"; // Disable scroll when modal is open
    } else {
      document.body.style.overflow = "auto"; // Enable scroll when modal is closed
    }

    // Cleanup when modal is closed or component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  const close = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const dropIn = useMemo(() => {
    return {
      hidden: {
        y: "100vh",
        opacity: 0,
      },
      visible: {
        y: "0",
        opacity: 1,
        transition: {
          duration: 0.3,
          type: "tween",
        },
      },
      exit: {
        y: "100vh",
        opacity: 0,
        transition: {
          duration: 0.3,
          type: "tween",
        },
      },
    };
  }, []);

  return (
    <AnimatePresence initial={false} exitBeforeEnter={true}>
      {open && (
        <motion.div className={classNames(styles["modal-cont"])}>
          <motion.div
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={classNames(styles["subContainer"])}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
